// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { addListener, removeListeners, makeEvent } from "~/lib/signals";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { store } from "~/state/store";
import { DEFAULT_DETAIL_STATE } from "~/state/detail/constants";
import { frpc } from "~/util/general";
import { isoZoneToUTC } from "~/util/format";

export const TYPES_BUS = [6001, 6009, 6507, 6513];
export const TYPES_TRAM = [6000, 6506];
export const TYPES_METRO = [6010, 6011, 6012, 6013, 6014, 6015, 6016, 6017, 6018, 6500, 6501, 6502, 6503, 6504, 6505, 6506];
export const TYPES_TRAIN = [6007, 6008, 6511, 6512];
export const TYPES_TROLEY = [6002, 6508];
export const TYPES_BOAT = [6006];
export const TYPES_CABLE = [6020];

export function typeIdToType(typeId) {
	if (TYPES_BUS.indexOf(typeId) != -1) { return "bus"; }
	if (TYPES_TRAM.indexOf(typeId) != -1) { return "tram"; }
	if (TYPES_METRO.indexOf(typeId) != -1) { return "metro"; }
	if (TYPES_TRAIN.indexOf(typeId) != -1) { return "vlak"; }
	if (TYPES_TROLEY.indexOf(typeId) != -1) { return "trolejbus"; }
	if (TYPES_BOAT.indexOf(typeId) != -1) { return "privoz"; }
	if (TYPES_CABLE.indexOf(typeId) != -1) { return "lanovka"; }

	return null;
}

/*
6009	Autobusové nádraží
6513	Autobusové nádraží
6016	Kabina metra A
6017	Kabina metra B
6018	Kabina metra C
6006	Přívoz
6020	Stanice lanovky
6503	Stanice metra A
6500	Stanice metra A/B
6502	Stanice metra A/C
6504	Stanice metra B
6501	Stanice metra B/C
6505	Stanice metra C
6008	Vlaková stanice
6512	Vlaková stanice
6007	Vlaková zastávka
6511	Vlaková zastávka
6010	Vstup do stanice metra A
6013	Vstup do stanice metra A/B
6015	Vstup do stanice metra A/C
6011	Vstup do stanice metra B
6014	Vstup do stanice metra B/C
6012	Vstup do stanice metra C
6508	Zastávka
6509	Zastávka
6510	Zastávka
6507	Zastávka
6506	Zastávka
6001	Zastávka autobusu
6000	Zastávka tramvaje
6002	Zastávka trolejbusu
*/

export default class TransportLines extends Content {
	constructor(data, options) {
		super(data, options);

		this._sc = [];
		this._sc.push(addListener(this, "change-active-type", "_seActiveType"));
		this._sc.push(addListener(this, "print-page", "_printPage"));
		this._sc.push(addListener(this, "print-done", "_printDone"));
	}

	destroy() {
		this._dom.loadButtons.forEach(function(item) {
			item.removeEventListener("click", this, false);
		});

		removeListeners(this._sc);

		super.destroy();
	}

	handleEvent(e) {
		if (e.target.tagName.toLowerCase() == "button") {
			var dataIndex = e.target.parentNode.getAttribute("data-index");
			var data = this._data[dataIndex];
			if (data.lines_count == data.lines.length) {
				for (var i = 0; i < this._dom.tabContents.length; i++) {
					if (this._dom.tabContents[i].classList.contains("active")) {
						this._dom.tabContents[i].innerHTML = "";
						this._buildLinesTables(this._dom.tabContents[i], data, null);
					}
				}
			}
			else {
				Mapy.getComponent("loader").start(true);
				e.target.parentNode.appendChild(Mapy.getComponent("loader").getBigCon());
				Mapy.getComponent("loader").sync();

				const frpcData = frpc({
					url: CONFIG.requestUrl + "/jrpoifrpc/",
					method: "transportLines",
					args: ["pubt", parseInt(this._options.id), data.type, 0, 0],
				});
				const cb = data => {
					this._loadAll(e.target, data);
				};

				frpcData.promise.then(cb, cb);
			}
			e.target.style.display = "none";
		}

		if (e.currentTarget.classList.contains("linetd")) { // klik na smer v uzkem sloupci
			var lineId = e.currentTarget.getAttribute("data-line-id");
			var direction = parseInt(e.currentTarget.getAttribute("data-line-direction"));
			var signId = parseInt(e.currentTarget.getAttribute("data-signid"));

			switch (e.type) {
				case "click":
					Mapy.getComponent("timeboard").setSheet(lineId, direction, undefined, undefined, signId);
					Mapy.getComponent("detail").openTimeboard();
					Mapy.getComponent("history").save();
				break;

				case "mouseenter":
				case "mouseleave":
					var index = e.currentTarget.closest(".transportlines-container").getAttribute("data-index");
					var signId = e.currentTarget.getAttribute("data-signid").split("|").map(function(item) {
						return parseInt(item, 10);
					});

					if (signId.length) {
						makeEvent("line-sign-highlight", this, { signId: signId, highlight: e.type == "mouseenter" });
					}
				break;
			}
		}

		if (e.currentTarget.classList.contains("tab") && e.currentTarget.tagName.toLowerCase() == "h3") { // klik na zalozku v uzke sloupci (typ dopravy)
			var type = e.currentTarget.getAttribute("data-log-type");
			this._activateType(type);
			makeEvent("request-sign-type", this, { type: type });
		}
	}

	openTimeboard() {
		Mapy.getComponent("timeboard").activate().setData(this._data, this._options.title, this._options.typeName);
	}

	_build() {
		this._dom.container.classList.add("card-content");
		this._dom.container.classList.add("content-transportlines");
		this._dom.tabContainer = node("div", {className:"thin-tabs"});
		this._dom.tabs = [];
		this._dom.tabContentsContainer = node("div", {className:"thin-items"});
		this._dom.tabContents = [];
		this._dom.loadButtons = [];
		this._dom.container.appendChild(this._dom.tabContainer);
		this._dom.container.appendChild(this._dom.tabContentsContainer);
		var timeboard = Mapy.getComponent("timeboard");
		var linesLimit = 10;

		for (var i = 0, len = this._data.length; i < len; i++) {
			var data = JSON.parse(JSON.stringify(this._data[i]));
			var lineType = node("h3", { className: "tab tab-" + data.type });
			this._dom.tabs.push(lineType);
			lineType.setAttribute("data-log-action", "transportlines-tab");
			lineType.setAttribute("data-log-type", data.type);
			lineType.addEventListener("click", this, false);
			lineType.insertAdjacentHTML("beforeend", '<img src="' + timeboard.getIcon(data.type) + '" /><span>' + data.label + "</span>");
			this._dom.tabContainer.appendChild(lineType);

			var cont = node("div", { className: "transportlines-container" });
			this._dom.tabContents.push(cont);
			cont.setAttribute("data-index", i);

			this._sortLines(data.lines);
			this._buildLinesTables(cont, data, linesLimit);

			var visibleLinesCount = Math.min(data.lines.length, linesLimit);
			if (data.lines_count && (data.lines_count > visibleLinesCount)) {
				var loadButton = node("button", { innerHTML: "+" + (data.lines_count - visibleLinesCount) + " " + _("detail.content.transportlines.more", { NUM: (data.lines_count - visibleLinesCount) }) });
				loadButton.addEventListener("click", this, false);
				cont.appendChild(loadButton);
				this._dom.loadButtons.push(loadButton);
			}

			this._dom.tabContentsContainer.appendChild(cont);
		}

		if (this._options.station) {
			this._activateType(typeIdToType(this._options.typeId));
			if (!this._dom.tabContainer.querySelector("h3.active")) { this._activateType(this._data[0].type); }
		} else {
			this._activateType(this._data[0].type);
		}

		if (Mapy.getComponent("timeboard").isActive()) { this.openTimeboard(); }
	}

	_buildLinesTables(cont, data, linesLimit) {
		var linesData = JSON.parse(JSON.stringify(data.lines));

		if (parseInt(this._options.id) != parseInt(this._options.station)) {
			var h3 = document.createElement("h3");
			h3.innerHTML = _("detail.content.transportlines.fromHere");
			cont.appendChild(h3);

			linesData = linesData.filter(function(a){ // vybereme jen linky, ktere jedou z daneho oznacniku
				a.departures = a.departures.filter(function(x){
					return x.signId.indexOf(parseInt(this._options.id)) != -1 ? true : false;
				}.bind(this));
				return a.departures.length ? a : false;
			}.bind(this));

			if (linesData.length) { // jen pokud jede z tohoto oznacniku nejaka linka
				var table = document.createElement("table");
				this._sortLines(linesData);
				table.appendChild(this._buildTable(linesData, data.type, linesLimit));
				cont.appendChild(table);
			}
			else { // jinak piseme info
				var info = document.createElement("p");
				info.innerHTML = _("detail.content.transportlines.noLinks");
				cont.appendChild(info);
			}

			linesData = JSON.parse(JSON.stringify(data.lines));
			linesData = linesData.filter(function(a){ // vybereme jen linky, ktere nejedou z daneho oznacniku
				a.departures = a.departures.filter(function(x){
					return x.signId.indexOf(parseInt(this._options.id)) == -1 ? true : false;
				}.bind(this));
				return a.departures.length ? a : false;
			}.bind(this));

			if (linesData.length) { // zobrazujeme jen pokud nejake linky jsou
				var h3 = document.createElement("h3");
				h3.innerHTML = _("detail.content.transportlines.others");
			}
		}

		if (linesData.length) { // zobrazujeme jen pokud nejake linky jsou
			var table = document.createElement("table");
			this._sortLines(linesData);
			table.appendChild(this._buildTable(linesData, data.type, linesLimit));
			if (parseInt(this._options.id) != parseInt(this._options.station) && h3) {
				cont.appendChild(h3);
			}
			cont.appendChild(table);
		}
	}

	_buildTable(lines, lineType, linesLimit) {
		var tbody = node("tbody");
		var linesCount = (linesLimit == null) ? lines.length : Math.min(linesLimit, lines.length);

		for (var x = 0; x < linesCount; x++) {
			for (var y = 0, l2 = lines[x].departures.length; y < l2; y++) {
				var tr = node("tr");
				//if (lines[x].departures[y].signId.indexOf(parseInt(this._options.id)) != -1) { tr.classList.add("selected"); }
				if (y == 0 && !(lineType == "metroa" || lineType == "metrob" || lineType == "metroc")) {
					var classSpan = 'number' + (lines[x].night ? " night" : "");
					if (lineType == "metro") { // metro dostane jeste classu podle sveho nazvu
						classSpan += " metro" + lines[x].title.toLowerCase();
					}
					var td1 = node("td", { className: "link", innerHTML: '<span class="' + classSpan + '">' + lines[x].title + "</span>" });
					td1.setAttribute("rowspan", l2);
					if (l2 == 1) { tr.classList.add("one-line"); }
					tr.appendChild(td1);
				}
				var td2 = node("td", { className: "linetd" });
				var departures = lines[x].departures[y].times.map(function(item) {
					var d = isoZoneToUTC(item.time);
					var minutes = d.getUTCMinutes().toString().lpad(0, 2);
					var hours = d.getUTCHours().toString();
					var daysToDeparture = (d - new Date()) / (1000 * 60 * 60 * 24);
					var days = "";
					switch (true) {
						// je to za vice nez tyden - dame cele datum
						case (daysToDeparture > 7):
							days = d.getUTCDate() + ". " + (d.getUTCMonth() + 1) + ". ";
						break;

						// je to vic nez den a mene nez tyden
						case (daysToDeparture < 7 && daysToDeparture > 1):
							days = _("detail.content.bigDays.nominativ." + d.getUTCDay()).toLowerCase() + " ";
						break;
					}
					return days + hours + ":" + minutes;
				});

				td2.setAttribute("data-line-id", lines[x].id);
				td2.setAttribute("data-line-direction", lines[x].departures[y].direction);
				td2.setAttribute("data-signId", lines[x].departures[y].signId.join("|"));
				td2.addEventListener("click", this, false);
				td2.addEventListener("mouseenter", this, false);
				td2.addEventListener("mouseleave", this, false);

				var link = Mapy.getComponent("timeboard").generateLink({
					line: lines[x].id,
					direction: lines[x].departures[y].direction
				});

				td2.insertAdjacentHTML("beforeend", '<a class="direction" href="' + link + '">&nbsp;<div>' + lines[x].departures[y].terminus + " <span>" + departures.join(", ") + "</span></div></a>");
				td2.querySelector("a.direction").addEventListener("click", function(e) {
					if (Mapy.Util.linkToNewWindow(e)) {
						return;
					}

					e.preventDefault();
				});
				tr.appendChild(td2);
				tbody.appendChild(tr);
			}
		}
		return tbody;
	}

	_activateType(type, fromTimeboard) {
		var state = fromTimeboard && !type;

		for (var i = 0; i < this._dom.tabs.length; i++) {
			this._dom.tabs[i].classList[state || this._dom.tabs[i].getAttribute("data-log-type") == type ? "add" : "remove"]("active");
			if (state) break;
		}
		for (var i = 0; i < this._dom.tabContents.length; i++) {
			var transportType = this._data[this._dom.tabContents[i].getAttribute("data-index")].type;
			this._dom.tabContents[i].classList[state || transportType == type ? "add" : "remove"]("active");
			if (state) break;
		}
	}

	_loadAll(button, e) {
		Mapy.getComponent("loader").end(true);
		Mapy.getComponent("loader").getBigCon().remove();

		if (e.status.toString().charAt(0) == "2" && e.poi && e.poi.extend && e.poi.extend.transportlines && e.poi.extend.transportlines.length) {
			var table = button.parentNode.querySelector("table");
			table.innerHTML = "";
			var transportType = this._data[button.parentNode.getAttribute("data-index")].type;
			table.appendChild(this._buildTable(e.poi.extend.transportlines[0].lines, transportType, null));
		} else {
			button.style.display = "";
		}
	}

	_typeForId(id) {
		for (var i = 0; i < this._options.signs.length; i++) {
			if (this._options.signs[i].id == id) {
				return typeIdToType(this._options.signs[i].typeId);
			}
		}
	}

	_seActiveType(e) {
		var type = e.data.type;
		this._activateType(type, true);
		const { id } = store.getState().detail;

		if (id !== DEFAULT_DETAIL_STATE.id) {
			this._options.id = [id]; // navraceni puvodniho oznacniku, ktery je otevren v detailu
		}

		makeEvent("request-sign-type", this, { type: type });
	}

	_sortLines(lines) {
		lines.sort(function(a, b){ // srovname linky od nejblizsiho casu odjezdu
			if (!a.departures.length) { return -1; }
			if (!b.departures.length) { return 1; }

			if (a.departures.length > 1) {
				a.departures.sort(function(c, d) {
					return isoZoneToUTC(c.times[0].time) < isoZoneToUTC(d.times[0].time) ? -1 : 1;
				});
			}

			if (b.departures.length > 1) {
				b.departures.sort(function(c, d) {
					return isoZoneToUTC(c.times[0].time) < isoZoneToUTC(d.times[0].time) ? -1 : 1;
				});
			}

			return isoZoneToUTC(a.departures[0].times[0].time) < isoZoneToUTC(b.departures[0].times[0].time) ? -1 : 1;
		});

		return lines;
	}

	_printPage() {
		if (Mapy.getComponent("timeboard").isActive()) {
			Mapy.getComponent("layout").setWidth(1, true);
		}
		for (var i = 0; i < this._dom.tabs.length; i++) {
			this._dom.tabContents[i].insertAdjacentElement('afterbegin', this._dom.tabs[i]);
		}
	}

	_printDone() {
		for (var i = 0; i < this._dom.tabs.length; i++) {
			this._dom.tabContainer.appendChild(this._dom.tabs[i]);
		}
	}
}
